import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import { KS_DOWNLOAD_URL } from '../../utils/Constants';

export const DownloadKS = () => (
  <Button
    variant="contained"
    size="small"
    component={RouterLink}
    to={KS_DOWNLOAD_URL}
    target="_blank"
    sx={theme => ({
      color: '#FFFFFF',
      backgroundColor: '#5959EB',
      '&:hover': {
        backgroundColor: '#43509B',
      },
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    })}
  >
    <FormattedMessage id="page.subscription.download.ks.btn" />
  </Button>
);
